export enum EKitManagementUrls {
  BASE_URL = 'ordering',
  WORKSHOP = 'workshop-part',
  PARENT = 'parent',
  HOSTS = 'hosts',
  LOCATIONS = 'locations',
  ORDER = 'order',
  NO_ADDRESS = 'no-address',
  EXPORT = 'export',
  SHIPPING_DETAILS = 'shipping-details',
  PARENT_ORDER = 'parent-order',
  KIT_ORDERS = 'kit-orders',
}

export const kitOrdersUrl = `${EKitManagementUrls.BASE_URL}/workshop/${EKitManagementUrls.KIT_ORDERS}`;
